export const GET_UNIV_CATEGORY_VIDEOS = "GET_UNIV_CATEGORY_VIDEOS";
export const RESET_UNIV_CATEGORY_VIDEOS = "RESET_UNIV_CATEGORY_VIDEOS";
export const SET_UNIV_CATEGORY_VIDEOS_REQUEST_STATUS = "SET_UNIV_CATEGORY_VIDEOS_REQUEST_STATUS";
